import axios from 'axios'

import { requestInterceptor } from './interceptors'

const api = axios.create({ baseURL: process.env.NEXT_PUBLIC_IRIS_API_URL })

api.interceptors.request.use(requestInterceptor)

export default api
